import React, { useContext, useState } from "react";
import { useIntl } from "react-intl";
import { Text, Checkbox, Radio, Input } from "react_reusable_components";
import { questionnaireTypeOptions, userRole } from "../../constants";
import { TwoColumn, TwoRow } from "../../core/layouts";
import { AuthContext } from "../../globalContext/auth/authProvider";
import { QuestionnaireContext } from "../../globalContext/questionnaire/questionnaireProvider";

import variables from "../../themes/base/styles/variables";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import ConfirmModalContainer from "../ConfirmModalContainer/ConfirmModalContainer";
import Style from "./AddQuestionnaireTopContainerStyle.module.scss";

const AddQuestionnaireTopContainerStyle = {
  mainWrapper: {
    background: variables.bodyBg,
    padding: variables.paddingSmall,
    gap: variables.gapSmaller,
    width: variables.fullWidth,
    border: `1px solid ${variables.grey4}`,
    overflow: "unset",
    marginRight: variables.paddingMedium,
    cursor: "pointer",
  },
  twoRowWrapper: {
    gap: variables.gapSmaller,
    overflow: "unset",
  },
  requiredStyle: {
    color: variables.primaryBg,
  },
  collapseIcon: {
    width: variables.iconWidth,
    height: variables.iconHeight,
    cursor: "pointer",
  },
};
const AddQuestionnaireTopContainer = ({
  questionnaireName,
  setQuestionnaireName,
  questionnaireType,
  setQuestionnaireType,
  markAsPrimary,
  setMarkAsPrimary,
  mode,
  setCollapseTop,
}) => {
  const intl = useIntl();
  const [authState] = useContext(AuthContext);
  const [questionnaireState] = useContext(QuestionnaireContext);

  const [openModal, setOpenModal] = useState(false);

  const handleInputChange = (e) => {
    setQuestionnaireName(e.target.value);
  };
  const handleSetPrimaryQuestionnaire = () => {
    setPrimaryQuestionnaire(
      questionnaireState,
      markAsPrimary,
      setMarkAsPrimary,
      setOpenModal
    );
  };

  const handleOnBlur = () => {
    if (questionnaireName && !openModal) {
      setCollapseTop(true);
    }
  };

  return (
    <>
      <TwoRow
        // onClick={() => {
        //   questionnaireName && setCollapseTop(true);
        // }}
        // onMouseLeave={handleOnBlur} uncomment when implimenting
        style={AddQuestionnaireTopContainerStyle.mainWrapper}
        topSection={
          <TwoColumn
            className={Style["upper-wrapper"]}
            leftSection={
              <TwoRow
                style={AddQuestionnaireTopContainerStyle.twoRowWrapper}
                topSection={
                  <Text className={Style["text-style"]} type="secondary">
                    {getLocalizedMessage(
                      intl,
                      mode === "edit"
                        ? "manageQuestionnaire.questionnaireType"
                        : "manageQuestionnaire.chooseType"
                    )}
                    {mode !== "edit" && (
                      <Text
                        style={AddQuestionnaireTopContainerStyle.requiredStyle}
                      >
                        &nbsp;*
                      </Text>
                    )}
                  </Text>
                }
                bottomSection={
                  <Radio.Group
                    value={questionnaireType}
                    onChange={(e) => setQuestionnaireType(e.target.value)}
                  >
                    {questionnaireTypeOptions.map((option) => (
                      <Radio
                        onMouseDown={(e) => e.preventDefault()}
                        key={option.value}
                        value={option.value}
                        disabled={mode === "edit"}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Text className={Style["radio-label-style"]}>
                          {option.label}
                        </Text>
                      </Radio>
                    ))}
                  </Radio.Group>
                }
              />
            }
            rightSection={
              <TwoColumn
                style={{ alignItems: "center" }}
                leftSection={
                  questionnaireType === 1 && (
                    <Checkbox
                      onMouseDown={(e) => {
                        e.preventDefault();
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      disabled={
                        authState?.currentRole?.id === userRole.CA ||
                        (mode === "edit" &&
                          questionnaireState?.primaryQuestionnaire?.id ===
                            questionnaireState?.questionnaireData
                              ?.questionnaireId)
                      }
                      checked={markAsPrimary}
                      className={Style["check-box-style"]}
                      text={
                        <Text className={Style["text-style"]} type="secondary">
                          {getLocalizedMessage(
                            intl,
                            "manageQuestionnaire.markPrimary"
                          )}
                        </Text>
                      }
                      onChange={handleSetPrimaryQuestionnaire}
                    />
                  )
                }
                rightSectionStyle={{
                  ...(questionnaireName && {
                    marginLeft: variables.marginMediumSmall,
                  }),
                }}
                rightSection={
                  questionnaireName && (
                    <img
                      style={AddQuestionnaireTopContainerStyle.collapseIcon}
                      alt="collapseIcon"
                      src={"/icons/collapseIcon.png"}
                      onClick={() => {
                        setCollapseTop(true);
                      }}
                    />
                  )
                }
              />
            }
          />
        }
        bottomSection={
          <Input
            className={Style["name-input-style"]}
            placeholder={getLocalizedMessage(
              intl,
              "manageQuestionnaire.namePlaceholder"
            )}
            onChange={handleInputChange}
            value={questionnaireName}
            onBlur={handleOnBlur}
            onClick={(e) => e.stopPropagation()}
          />
        }
      />
      <ConfirmModalContainer
        open={openModal}
        setOpen={setOpenModal}
        question={getLocalizedMessage(
          intl,
          "manageQuestionnaire.replaceBaseQuestionnaire"
        )}
        iconSrc={"/icons/warningIcon.svg"}
        onConfirm={() => {
          setMarkAsPrimary(true);
          setOpenModal(false);
        }}
        descriptionText={getLocalizedMessage(
          intl,
          "manageQuestionnaire.modal.description",
          { name: questionnaireState?.primaryQuestionnaire?.name }
        )}
        restStyle={{ backgroundColor: variables.primaryBg }}
      />
    </>
  );
};

export default AddQuestionnaireTopContainer;

function setPrimaryQuestionnaire(
  questionnaireState,
  markAsPrimary,
  setMarkAsPrimary,
  setOpenModal
) {
  if (questionnaireState?.primaryQuestionnaire?.isPrimary) {
    if (markAsPrimary) {
      setMarkAsPrimary(false);
    } else {
      setOpenModal(true);
    }
  } else {
    setMarkAsPrimary((prev) => !prev);
  }
}
